export default __webpack_public_path__ + "./images/sl.5350df04.png";